import CardStack from '@shared/components/core/card/CardStack';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

export interface IOrgProductLandingProps {
    orgId: string;
}

export default function OrgProductLanding({ orgId }: IOrgProductLandingProps) {
    const { t } = useTranslation();

    if (!orgId) return null;
    return (
        <CardStack
            name="orgTransaction"
            title={t('common:license.key.product.titleLong')}
            description={t('common:license.key.product.description')}>
            <OrgLinks organizationId={orgId} variant={'orgProduct'} />
        </CardStack>
    );
}
